import { UBLSender, useUBL } from '@common/log-manager';

/**
 * @deprecated '@common/log-manager' 의 `UBLSender` 를 사용해주세요.
 */
export type CheckoutUBLSender = UBLSender;

/**
 * @deprecated '@common/log-manager' 의 `useUBL` 를 사용해주세요.
 */
export function useCheckoutUBL() {
  return useUBL();
}
